import {BaseApi} from "@/http/api/BaseApi";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import {ProductParamsType} from "@/types/productParamsType";
import ISingleProduct from "@/interface/api/single-product";
import {SingleProductApiResponse} from "@/types/api/single-product";


export default class SingleProductServices extends BaseApi implements ISingleProduct {

    cancelAvailable = async (id: string): Promise<SingleProductApiResponse | undefined> => {
        if (!Cookies.get("token")) return
        try {
            const response: any = await this.delete(`products/${id}/notify-when-available`, {
                headers: {
                    "Authorization": `Bearer ${Cookies.get("token")}`
                },
                next: {
                    tags: ["wish"]
                }
            })

            if (response.statusCode == 200 || response.statusCode == 201) {
                const message: string = response?.message
                toast.success(message, {
                    position: "top-center",
                })
                return response.data
            } else {
                return Promise.reject({message: response})
            }
        } catch (error: any) {
            const errorMessage: string = error?.message?.messages
            toast.error(errorMessage, {
                position: "top-center",
            })
        }
    }

    checkAvailable = async (id: string): Promise<SingleProductApiResponse | undefined> => {
        if (!Cookies.get("token")) return
        try {
            const response: any = await this.get(`products/${id}/notify-exists`, {
                headers: {
                    "Authorization": `Bearer ${Cookies.get("token")}`
                },
                next: {
                    tags: ["wish"]
                }
            })

            if (response.statusCode == 200 || response.statusCode == 201) {
                return response.data
            } else {
                return Promise.reject({message: response})
            }

        } catch (error: any) {
            return Promise.reject(error?.message?.messages)
        }


    }
    getSingleProduct = async ({slug}: ProductParamsType): Promise<SingleProductApiResponse> => {
        try {
            return this.get(`products/${slug}`, {
                next: {
                    tags: ["product", slug],
                    revalidate: 3600
                }
            })
        } catch (e) {
            return await Promise.reject(e)
        }
    }

    addAvailable = async (id: string): Promise<SingleProductApiResponse | undefined> => {
        if (!Cookies.get("token")) return
        try {
            const response: any = await this.get(`products/${id}/notify-when-available`, {
                headers: {
                    "Authorization": `Bearer ${Cookies.get("token")}`
                },
                next: {
                    tags: ["wish"]
                }
            })

            if (response.statusCode == 200 || response.statusCode == 201) {
                const message: string = response?.message
                toast.success(message, {
                    position: "top-center",
                })
                return response.data
            } else {
                return Promise.reject({message: response})
            }

        } catch (error: any) {
            const errorMessage: string = error?.message?.messages
            toast.error(errorMessage, {
                position: "top-center",
            })
        }
    }


    productItemDataLayer = async (modelId: number) => {
        try {
            const response: any = await this.get(`product-items/data-layer?type=view_item&modelId=${modelId}&quantity=1&paymentType=null`, {
                headers: {
                    "Authorization": `Bearer ${Cookies.get("token")}`
                },
            })

            if (response.statusCode == 200 || response.statusCode == 201) {
                return response.data
            } else {
                return Promise.reject({message: response})
            }

        } catch (error: any) {
            const errorMessage: string = error?.message?.messages
            toast.error(errorMessage, {
                position: "top-center",
            })
        }
    }


}